import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'


export default function ViewCustomer() {
  const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [supplier, setSupplier] = useState();
    const [products, setProducts] = useState();

    

    console.log("view supplier page")

    // Load user
    useEffect(() => {
        console.log("loading supplier...",params.id);

       
            axios
              .get(`https://${process.env.REACT_APP_IP}/api/suppliers/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
              })
              .then((res) => {
                console.log("Supplier:", res.data);
                setSupplier(res.data);
                setLoading(false);

                  // now load the products
                  axios.get(`https://${process.env.REACT_APP_IP}/api/products/?supplierId=${params.id}`, {
                      headers: { Authorization: `bearer ${user.token}` },
                  })
                      .then((res) => {
                         
                          setProducts(res.data.data)

                      })

              })
              .catch((err) => {
                  console.log(err);
                  setLoading(false);

                  if (err.response.status === 401) {
                      dispatch({ type: "LOGOUT" })
                      navigate("../")
                  }
              });
          
    }, [])

    
    
    return (
        <div className="page">
            {loading && (<Spinner />)}
            {!loading && supplier && (
                <>
                    {/* Heading  */}
                    <div className="row">
                        <div className="col-12">
                            <h1>
                                {supplier.name}
                                <Link to={`/Suppliers/Edit/${supplier.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>
                            </h1>
                        </div>
                    </div>

                    {/* Details  */}
                    <div className="row">
                        <div className="col-6">
                  
                        
                       
                
                            <h3>Supplier Details</h3>

                            {/* Supplier Name */ }
                            <div className="row">
                                <div className="col-4">
                                    Supplier Name
                                </div>
                                <div className="col-8">
                                    {supplier.name}
                                </div>
                            </div>

                            {/* Address */} 
                            <div className="row">
                                <div className="col-4">
                                    Address
                                </div>
                                    <div className="col-8" style={{ whiteSpace: "pre-line"}}>
                                    {supplier.address}
                                </div>
                            </div>
                            {/* Postcode */}
                            <div className="row">
                                <div className="col-4">
                                    Postcode
                                </div>
                                <div className="col-8">
                                    {supplier.postcode}
                                </div>
                            </div>
                            {/* Telephone */}
                            <div className="row" style={{marginTop: 10}}>
                                <div className="col-4">
                                    Telephone
                                </div>
                                <div className="col-8">
                                    {supplier.telephone}
                                </div>
                            </div>
                            {/* Email */}
                            <div className="row">
                                <div className="col-4">
                                    Email
                                </div>
                                <div className="col-8">
                                    {supplier.email}
                                </div>
                            </div>

                            {/* Notes */}
                            <div className="row" style={{marginTop:20}}>
                                <div className="col-12">
                                    Notes
                                </div>
                                <div className="col-12" style={{ whiteSpace: "pre-line" }}>
                                    {supplier.notes}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">

                            <h3>Other Details</h3>

                            {/* Account Number */}
                            <div className="row">
                                <div className="col-4">
                                    Account Number
                                </div>
                                <div className="col-8">
                                    {supplier.accountNumber}
                                </div>
                            </div>

                       
                            {/* Who Invoices? */}
                            <div className="row">
                                <div className="col-4">
                                    Who Invoices?
                                </div>
                                <div className="col-8">
                                    {supplier.afsToInvoice ? "AFS To Invoice" : "Supplier To Invoice"}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Products  */}
                    {products && (
                        <>
                        <div className="row">
                            <div className="col-12">
                                    <h3>Products <button className="btn-sm btn-primary" onClick={() => { navigate(`/Products/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button></h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                    <div className="row">
                                        <div className="col-12">
                                            <table style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 120 }}>Code</th>
                                                        <th style={{ width: 150 }} className="d-none d-md-table-cell">Type</th>
                                                        <th>Product</th>
                                                        <th style={{ width: 100 }} className="d-none d-lg-table-cell">Cost Price</th>
                                                        <th style={{ width: 100 }} className="d-none d-lg-table-cell">Sale Price</th>
                                                        <th style={{ width: 140 }}>Options</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {products && (products.map((product) => 
                                                         (
                                                            <tr key={product.id} style={{ cursor: "pointer" }}>
                                                                <td onClick={() => { navigate(`/Products/View/${product.id}`) }}>{product.code}</td>
                                                                <td onClick={() => { navigate(`/Products/View/${product.id}`) }} className="d-none d-md-table-cell">{product.type}</td>
                                                                <td onClick={() => { navigate(`/Products/View/${product.id}`) }}>{product.name}</td>
                                                                <td onClick={() => { navigate(`/Products/View/${product.id}`) }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>{product.costPrice.toFixed(2)}</td>
                                                                <td onClick={() => { navigate(`/Products/View/${product.id}`) }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>{product.salePrice.toFixed(2)}</td>
                                                                <td>
                                                                    <Link to={`/Products/View/${product.id}`} className="btn-sm btn-primary">View</Link>
                                                                    <Link to={`/Products/Edit/${product.id}`} className="btn-sm btn-other">Edit</Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                            </div>
                        </div>
                        </>
                    )}
             </>
            )}
        </div>
  )
}
